// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import Collection from "../../lib/collection";

export default class OnlineAppCollection extends Collection {

    constructor(onlineApp=null,...items) {
        super(...items);
    }

}